import React from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'
import CloudCircleIcon from '@material-ui/icons/CloudCircle'
import WhatshotIcon from '@material-ui/icons/Whatshot'
import OpacityIcon from '@material-ui/icons/Opacity'
import InvertColorsIcon from '@material-ui/icons/InvertColors'
import ToysIcon from '@material-ui/icons/Toys'
import CloudQueueIcon from '@material-ui/icons/CloudQueue'
import FilterDramaIcon from '@material-ui/icons/FilterDrama'
import AppShell from './components/layout/AppShell'
import PageCard from './components/ui/PageCard'
import Airbox2 from './airboxDashboard/Airbox2'

class Airbox2Dashboard extends React.Component {
  state = { group: {} }

  async getGroupData() {
    const uniqid = this.props.match.params.uniqid
    try {
      const result = await fetch(`/api/getGroupData?uniqid=${uniqid}`, {
        mode: 'cors',
        method: 'GET',
      })
      const data = await result.json()
      if (data.success) this.setState({ group: data.data })
      else this.props.history.push('/groups')
    } catch (err) {
      this.props.history.push('/groups')
    }
  }

  componentDidMount() {
    this.getGroupData()
  }

  buildSecondaryNav() {
    const { match, location } = this.props
    const items = [
      { key: 'co', label: '一氧化碳', path: 'co', icon: <CloudCircleIcon /> },
      { key: 'humidity', label: '濕度', path: 'humidity', icon: <OpacityIcon /> },
      { key: 'hcho', label: '甲醛', path: 'hcho', icon: <InvertColorsIcon /> },
      { key: 'pm1', label: 'PM1', path: 'pm1', icon: <FilterDramaIcon /> },
      { key: 'pm10', label: 'PM10', path: 'pm10', icon: <CloudQueueIcon /> },
      { key: 'pm25', label: 'PM25', path: 'pm25', icon: <CloudCircleIcon /> },
      { key: 'temperature', label: '溫度', path: 'temperature', icon: <WhatshotIcon /> },
      { key: 'tvoc', label: '揮發性有機物', path: 'tvoc', icon: <ToysIcon /> },
      { key: 'co2', label: '二氧化碳', path: 'co2', icon: <CloudQueueIcon /> },
    ]
    return items.map((item) => ({
      ...item,
      to: `${match.url}/${item.path}`,
      active: location.pathname.includes(`/${item.path}`),
    }))
  }

  render() {
    const { match } = this.props
    const uniqid = match.params.uniqid
    return (
      <AppShell
        uniqid={uniqid}
        title={`環境 (II) · ${this.state.group.name || ''}`}
        subtitle={this.state.group.description}
        secondaryNav={this.buildSecondaryNav()}
      >
        <PageCard>
          {[
            'co',
            'humidity',
            'hcho',
            'pm1',
            'pm10',
            'pm25',
            'temperature',
            'tvoc',
            'co2',
          ].map((resource) => (
            <Route
              key={resource}
              path={`${match.url}/${resource}`}
              render={() => (
                <Airbox2
                  group_name={this.state.group.name}
                  search={this.props.location.search}
                  resource={resource}
                  uniqid={uniqid}
                />
              )}
            />
          ))}
        </PageCard>
      </AppShell>
    )
  }
}

Airbox2Dashboard.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
}

export default Airbox2Dashboard
